export default {
  install(Vue, _options) {
    Vue.prototype.$posthog = window.posthog;
  },
};
